import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { flatten, values } from "lodash";
import { ContentChange } from "ngx-quill";

import { AssessmentSection } from "../../assessment.type";
import { PreviousRecommendationRubricMixin } from "../../previous-recommendation-rubric-mixin/previous-recommendation-rubric.mixin";

@Component({
  selector: "app-rubric-section-assess-form",
  templateUrl: "./rubric-section-assess-form.component.html",
  styleUrls: [
    "./rubric-section-assess-form.component.css",
    "../../submission-comments/submission-comments.component.css",
  ],
})
export class RubricSectionAssessFormComponent
  extends PreviousRecommendationRubricMixin
  implements OnInit
{
  @Input() section: AssessmentSection;
  assessmentType = "section";
  criterionComments = {};
  criterionLevels = {};
  @Input() parentForm: UntypedFormGroup;

  ngOnInit() {
    this.commentsInfo = this.getCommentsInfo(
      this.section.rubric?.criterions || []
    );
    if (this.section.rubric) {
      this.criterionComments = this.parentForm.controls.rubric_recommendations
        .get(this.section.rubric.formArrayIndex.toString())
        .get("comments").value;
      this.criterionLevels = flatten(
        values(
          this.parentForm.controls.rubric_recommendations
            .get(this.section.rubric.formArrayIndex.toString())
            .get("criterion_levels").value
        )
      );
    }
  }

  onCommentChange(event: ContentChange) {
    this.parentForm.controls.rubric_recommendations
      .get(this.section.rubric.formArrayIndex.toString())
      .get("comments")
      .get(event.source)
      .setValue(event.html);
  }

  setRubricRecommendationCriterionLevel(
    criterionLevelId: number,
    criterionId: number
  ) {
    this.parentForm.controls.rubric_recommendations
      .get(this.section.rubric.formArrayIndex.toString())
      .get("criterion_levels")
      .get(`criterion_${criterionId}`)
      .setValue(criterionLevelId);
  }
}
